module.exports = __webpack_public_path__ + "static/img/kaichuang.92671b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/tijianbaogao/kaichuang.jpg
// module id = zapt
// module chunks = 9